/**
 * The chat page's reading measure. Transcript and composer share this so the
 * left edge never shifts between them.
 */
export const CHAT_PAGE_MEASURE = 'mx-auto w-full max-w-4xl px-6'

/** Shared width for the New Chat composer and its suggested work or prompts. */
export const CHAT_LANDING_MEASURE = 'mx-auto w-full max-w-3xl px-6'

/**
 * Column the title and the transcript scrollbar share. Wider than the reading
 * measure so the thumb sits on the title rule, not the pane edge or the prose.
 */
export const CHAT_PAGE_COLUMN = 'mx-auto w-full max-w-5xl'

/**
 * Header chrome is a bit wider than the transcript — room for the ingest
 * action row — without spanning the whole column.
 */
export const CHAT_PAGE_HEADER_MEASURE = 'mx-auto w-full max-w-5xl px-6'
